import { render, staticRenderFns } from "./AddBudgetType.vue?vue&type=template&id=095e2c06&scoped=true"
import script from "./AddBudgetType.vue?vue&type=script&lang=js"
export * from "./AddBudgetType.vue?vue&type=script&lang=js"
import style0 from "./AddBudgetType.vue?vue&type=style&index=0&id=095e2c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e2c06",
  null
  
)

export default component.exports